import {useEffect, useRef} from 'react';

import useModalRoute from '@/hooks/useModalRoute';
import usePullToCollapse from '@/hooks/usePullToCollapse';
import useScrollMessages from '@/hooks/useScrollMessages';
import uwmMessageService from '@/services/uwm/uwmMessageService';

import InsightSection from './InsightSection';
import ScoreSection from './ScoreSection';

const ExperienceScoreMain = () => {
    const scrollRef = useRef<HTMLDivElement>(null);
    useScrollMessages(scrollRef);
    usePullToCollapse(scrollRef, uwmMessageService.sendInsightCollapse);

    const {isDetailOpen: isDetailedInsightOpen} = useModalRoute();
    const wasDetailedInsightOpenRef = useRef(isDetailedInsightOpen);

    useEffect(() => {
        if (wasDetailedInsightOpenRef.current && !isDetailedInsightOpen) {
            scrollRef.current?.scrollTo({top: 0});
        }

        wasDetailedInsightOpenRef.current = isDetailedInsightOpen;
    }, [isDetailedInsightOpen]);

    return (
        <main
            ref={scrollRef}
            // --menu-inset is what the host menu covers; the rest is the gap under the last tiles.
            className='relative flex h-dvh w-full flex-col overflow-y-auto overflow-x-hidden px-4 pt-inset-4 pb-[calc(var(--menu-inset,0px)+2rem)] text-primary dark:bg-orion-1 dark:text-romance'
        >
            <ScoreSection />
            <InsightSection />
        </main>
    );
};

export default ExperienceScoreMain;
